module.exports = __webpack_public_path__ + "img/missed-sla.79c3dd2a.svg";